<script>
  import { sendPasswordResetEmail } from '../Api/api';
  import Button from './Common/Button.svelte';

  let inputMail = '';
  let errorMessage = '';
  let resetEmailSent = false;

  function validateEmail() {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(inputMail)) {
      errorMessage = 'Angi en gyldig e-postadresse';
    } else {
      errorMessage = '';
      sendPasswordResetEmail(inputMail);
      resetEmailSent = true;
    }
  }
</script>

{#if !resetEmailSent}
  <input type="email" placeholder="E-post" bind:value={inputMail} />
  <p class="error">{errorMessage}</p>
  <div class="btn-container">
    <Button on:click={validateEmail}>Reset passord</Button>
  </div>
{:else}
  <p>Du vil etter kort tid motta en e-post med en lenke hvor du kan bytte passordet ditt.</p>
{/if}

<style>
  .btn-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
  input {
    font-size: 16px;
    border: none;
    outline: none;
    margin-bottom: 10px;
    border-radius: 4px;
    width: 300px;
    padding: 10px;
  }

  p.error {
    color: #f96b6a;
  }
</style>
